module.exports = __webpack_public_path__ + "static/media/onboarding-3.61b3b9af.png";